<template lang="pug">
  b-container(fluid)
    h2
      .d-flex.align-items-center
        span {{name}}
        h6.d-inline-block.mb-1.ml-3
          b-spinner(small, variant="primary", v-if="loading")
    .get-started
      p.mb-0 Botón Inicio
      p.text-secondary Este botón permite iniciar una conversación enviando al usuario a tu bloque principal.
      block-connector(:flow_id="get_started.flow_id", important-only, :next_block_id="get_started.next_block", @change="updateConnector(get_started, $event)")
      .text-center
        b-link.text-sm.text-danger(@click="removeGetStarted", v-if="has_get_started") Quitar botón
    hr
    .menu
      p.mb-0 Menú persistente
      p.text-secondary Son opciones disponibles en la conversación que te permiten envíar a un bloque definido.
      b-alert(variant="warning", :show="!has_get_started")
        p.mb-0 Necesitas configurar el Botón Inicio para usar el menú persistente.
      .menu-container(v-show="has_get_started")
        b-input-group.mb-2(v-for="(menu, index) in persistent_menu.call_to_actions", :key="'menu_' + index")
          b-form-input(placeholder="Título de botón", v-model="menu.title", trim)
          b-input-group-append
            block-connector(:flow_id="menu.flow_id", :next_block_id="menu.next_block", important-only, :type="menu.type", :url="menu.url", buttonOnly, @change="updateConnector(menu, $event)")
          b-input-group-append
            b-button(variant="soft-danger", @click="persistent_menu.call_to_actions.splice(index, 1)")
              trash-2-icon.icon-sm
      b-row.mb-3(v-show="can_add_menu")
        b-col.my-1(lg="4", offset-lg="2")
          b-button(variant="light", block, @click="addMenuItem('postback')" :disabled="loading") + Agregar conector
        b-col.my-1(lg="4")
          b-button(variant="light", block, @click="addMenuItem('web_url')" :disabled="loading") + Agregar botón web
      b-alert(variant="warning", :show="!menu_limit && has_get_started", dismissible)
        p.mb-0 Solo se permite tener tres opciones de menú persistente
    hr
    .domains
      p.mb-0 Dominios permitidos
      p.text-secondary Las vistas web necesitan estar registradas en la lista de dominios permitidos para que se puedan mostrar en la conversación.
      .pr-2.mb-2
        b-input-group.mb-2(v-for="(domain, index) in whitelisted_domains", :key="'domain_' + index")
          b-form-input(placeholder="https://", v-model="whitelisted_domains[index]", trim)
          b-input-group-append
            b-button(variant="soft-danger", @click="whitelisted_domains.splice(index, 1)")
              trash-2-icon.icon-sm
      .text-center.my-1
        b-button(variant="light", @click="addDomain") + Agregar dominio
    b-button.mt-4(variant="primary", block, @click="saveProfile", :disabled="loading") Guardar configuración
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      get_started: {
        type: 'next_block',
        next_block: null,
        flow_id: null
      },
      persistent_menu: {
        locale: '',
        composer_input_disabled: false,
        call_to_actions: []
      },
      whitelisted_domains: []
    }
  },
  props: {
    name: {
      default: ''
    },
    model_id: {
      default: null
    }
  },
  computed: {
    has_get_started () {
      return !!this.get_started.next_block && !!this.get_started.flow_id;
    },
    menu_limit () {
      return this.persistent_menu.call_to_actions.length < 3
    },
    can_add_menu () {
      return this.menu_limit && this.has_get_started
    }
  },
  methods: {
    ...mapActions(['facebook/get_messenger_profile', 'facebook/set_messenger_profile']),
    getProfile(){
      let self = this
      this.loading = true

      this['facebook/get_messenger_profile']({
        account_id: self.$route.params.account_id,
        model_id: self.model_id,
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.get_started = Object.assign(self.get_started, res.resource.get_started)
            self.persistent_menu = Object.assign(self.persistent_menu, res.resource.persistent_menu)
            self.persistent_menu.call_to_actions = self.persistent_menu.call_to_actions.map(c => {
              c.type = c.url ? 'web_url' : 'postback'
              return c
            })
            self.whitelisted_domains = res.resource.whitelisted_domains.slice();
          }
        }
      })
    },
    removeGetStarted () {
      this.get_started = {
        type: 'next_block',
        next_block: null,
        flow_id: null
      };
    },
    updateConnector(element, data) {
      if(element.type === 'web_url') {
        element.url = data.url
      } else {
        element.flow_id = data.flow_id
        element.next_block = data.next_block_id
      }
    },
    addMenuItem (type) {
      let item = {
        title: "",
        type: type,
      }

      if(type === 'postback') {
        item.next_block = null
        item.flow_id = null
      } else {
        item.url = ""
        item.webview_height_ratio = "full"
      }
      this.persistent_menu.call_to_actions.push(item);
    },
    addDomain () {
      this.whitelisted_domains.push('')
      this.$nextTick(() => {
        $('.whitelist-container').scrollTop($('.whitelist-container')[0].scrollHeight)
      })
    },
    saveProfile () {
      let self = this;
      this.loading = true;
      let data = {};

      if(this.has_get_started) {
        data.get_started = {
          payload: JSON.stringify([{
            type: 'next_block',
            payload: {
              next_block_id: self.get_started.next_block,
              flow_id: self.get_started.flow_id
            }
          }])
        }
      }

      if(this.persistent_menu.call_to_actions.length) {
        data.persistent_menu = [
          {
            locale: self.persistent_menu.locale,
            composer_input_disabled: self.persistent_menu.composer_input_disabled,
            call_to_actions: []
          }
        ]

        for(var item of this.persistent_menu.call_to_actions) {
          if (item.type == 'web_url') {
            data.persistent_menu[0].call_to_actions.push(item)
          } else {
            data.persistent_menu[0].call_to_actions.push({
              type: 'postback',
              title: item.title,
              payload: JSON.stringify([{
                type: 'next_block',
                payload: {
                  next_block_id: item.next_block,
                  flow_id: item.flow_id
                }
              }])
            })
          }
        }
      }

      if(this.whitelisted_domains.length) {
        data.whitelisted_domains = this.whitelisted_domains.slice();
      }

      this['facebook/set_messenger_profile']({
        account_id: self.$route.params.account_id,
        model_id: self.model_id,
        ...data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Perfil actualizado')
          }
        }
      })
    },
  },
  mounted () {
    this.getProfile()
  }
}
</script>

<style lang="scss" scoped>
  .menu-item {
    position: relative;
    box-sizing: border-box;
    &:hover {
      .menu-delete {
        display: inline-block;
      }
    }
  }

  .menu-actions {
    position: absolute;
    right: 5px;
  }

  .menu-delete {
    display: none;
  }

  .whitelist-container {
    max-height: 400px;
  }
</style>
